<ng-container [ngTemplateOutlet]="addRecurringInvoice"></ng-container>
<ng-container [ngTemplateOutlet]="groupBySiteView"></ng-container>
<ng-container *ngIf="isForm">
  <table *ngIf="bShowForm" class="table table-layout-fixed table-borderless mb-0" width="100%">
    <tr>
      <td width="25%">
        <label>{{ 'repeated_every' | translate }}<required-tag></required-tag></label>
        <div class="input-group">
          <input
          type="number"
          [required]="true"
          class="form-control font-size-11"
          id="strQuantity"
          [(ngModel)]="objRecurringInvoice.repeated_every_quantity"
          [ngModelOptions]="{ name: 'strQuantity' }"
          (change)="onIntervalChange(objRecurringInvoice)"
          style="width: 25%; height: 36px;">
          <ng-select
            [items]="arFrequencyList"
            [clearable]="true"
            id="strFrequency"
            [(ngModel)]="objRecurringInvoice.repeated_every_frequency"
            [ngModelOptions]="{ name: 'strFrequency' }"
            [required]="true"
            [ngClass]="{'is-invalid': !isValid  && isTouched && !item.readonly}"
            class="font-size-11 input-height-40 ml-1"
            name="strFrequency"
            bindLabel="text"
            bindValue="id"
            style="width: 50%;"
            (change)="onIntervalChange(objRecurringInvoice)"
            appendTo="body"
          >
            <ng-template ng-option-tmp let-item="item" class="font-size-11">
              {{ item.text | translate }}
            </ng-template>

            <ng-template ng-label-tmp let-item="item" class="font-size-11">
              {{ item.text | translate }}
            </ng-template>
          </ng-select>
        </div>
      </td>
      <td width="25%">
        <label>{{ 'next_invoice_date' | translate }}<required-tag></required-tag></label>
        <div class="input-group">
          <input
            [(ngModel)]="objRecurringInvoice.next_invoice_date"
            [owlDateTime]="objFieldNextInvoiceDate"
            [ngModelOptions]="{ name: 'objNextInvoiceDate' }"
            [required]="true"
            [readonly]="true"
            type="text"
            id="next_invoice_date_txt"
            class="form-control date-input"
          />
          <button class="calendar-button" type="button" [owlDateTimeTrigger]="objFieldNextInvoiceDate"  (dateTimeChange)="updateParentForm()">
            <fa-icon [icon]="['fal', 'calendar']" style="color:#fff;" ></fa-icon>
          </button>
        </div>
        <div><owl-date-time #objFieldNextInvoiceDate pickerType="calendar"></owl-date-time></div>
      </td>
      <td width="25%">
        <label>{{ 'invoice_date' | translate }}<required-tag></required-tag></label>
        <ng-select
          [items]="objMetadata['invoice_date'].options"
          [clearable]="false"
          [(ngModel)]="objRecurringInvoice.invoice_date"
          [ngModelOptions]="{ name: 'objInvoiceDate' }"
          [bindValue]
          [class.is-invalid]="objInvoiceDate.touched && !objInvoiceDate.valid"
          #objInvoiceDate="ngModel"
          required
          class="value-text"
          appendTo="body"
          (change)="updateParentForm()"
        >
          <!-- DISPLAY IN SELECTED -->
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ item.text | translate }}</span>
          </ng-template>
          <!-- DISPLAY IN OPTION -->
          <ng-template  ng-option-tmp let-item="item">
            <span class="value-text"> {{ item.text | translate }}</span>
          </ng-template>
        </ng-select>
      </td>
      <td width="25%">
        <label>{{ 'due_date' | translate }}<required-tag></required-tag></label>
        <ng-select
          ngDefaultControl
          [(ngModel)]="objRecurringInvoice.payment_terms_id.value"
          (open)="objRecurringInvoice.payment_terms_id.loadDataOnClick()"
          [items]="objRecurringInvoice.payment_terms_id.source | async"
          [loading]="objRecurringInvoice.payment_terms_id.loader"
          [typeahead]="objRecurringInvoice.payment_terms_id.typehead"
          [ngModelOptions]="{standalone: true}"
          bindLabel="text"
          appendTo="body"
          (change)="updateParentForm()"
        ></ng-select>
      </td>
    </tr>
    <tr>
      <td colspan="5">
          <app-recurring-invoices-line-items
            [customerId]="customerId"
            [recurringInvoiceConfig]="objRecurringInvoiceConfig"
            (onLineItemChange)="updateLineItemData($event)"
          ></app-recurring-invoices-line-items>
      </td>
    </tr>
  </table>
</ng-container>

<ng-template #addRecurringInvoice>
  <div class="row pb-3">
    <div class="col-12 text-right">
      <button *ngIf="!bShowForm" class="btn btn-success btn-sm fs-11" (click)="createForm()">
        <fa-icon [icon]="['fas', 'plus']"></fa-icon> {{ 'add_recurring_invoice' | translate }}
      </button>
      <button *ngIf="bShowForm" class="btn btn-danger btn-sm fs-11" (click)="deleteForm()">
        <fa-icon [icon]="['fas', 'times']"></fa-icon> {{ 'cancel' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #groupBySiteView>
  <ng-container *ngIf="!bLoading; else loading">
  <ng-container *ngIf="arSiteList.length; else noRecordFound">
    <mat-accordion>
      <ng-container *ngFor="let site of arSiteList; index as siteIndex">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title matTooltip="{{ 'site' | translate }}: {{ site.text ? site.text : 'no_site' | translate }}">
              {{ site.text ? site.text : 'no_site' | truncate: 80 | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table class="table mb-0 record-texts fs-11" width="100%">
            <ng-container *ngIf="site.recurring_invoices.length">
              <ng-container *ngFor="let recurring_invoice of site.recurring_invoices; index as recurringJobIndex">
                <tr>
                  <td width="20%" class="truncate">
                    <span matTooltip="{{ 'repeated_every' | translate }}: {{ formatRepeated(recurring_invoice.repeated_every) | placeholdWithString }}">
                      <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                      {{ formatRepeated(recurring_invoice.repeated_every) | placeholdWithString }}
                    </span>
                  </td>
                  <td width="35%" class="truncate">
                    <ul class="fa-ul ml-0 truncate">
                      <li matTooltip="{{ 'next_invoice_date' | translate }}: {{ recurring_invoice.next_invoice_date | date:'mediumDate' | placeholdWithString }}">
                        {{ 'next_invoice_date' | translate }}: {{ recurring_invoice.next_invoice_date | date:'mediumDate' | placeholdWithString | truncate }}
                      </li>
                      <li matTooltip="{{ 'last_invoice_date' | translate }}: {{ recurring_invoice.last_invoice_date | date:'mediumDate' | placeholdWithString }}">
                        {{ 'last_invoice_date' | translate }}: {{ recurring_invoice.last_invoice_date | date:'mediumDate' | placeholdWithString | truncate }}
                      </li>
                    </ul>
                  </td>
                  <td width="25%" class="truncate">
                    <ul class="fa-ul ml-0 truncate">
                      <li matTooltip="{{ 'amount_tax_excluded' | translate }}: {{ recurring_invoice.amount_tax_ex | currency }}">
                        {{ 'amount_tax_excluded' | translate }}: {{ recurring_invoice.amount_tax_ex | currency }}
                      </li>
                      <li matTooltip="{{ 'amount_tax_included' | translate }}: {{ recurring_invoice.amount_tax_inc | currency }}">
                        {{ 'amount_tax_included' | translate }}: {{ recurring_invoice.amount_tax_inc | currency }}
                      </li>
                    </ul>
                  </td>
                  <td width="10%" class="text-right">
                    <a *ngIf="recurring_invoice.id"
                      class="pl-1 pr-1 pb-2 pt-2 cursor-pointer"
                      (click)="editRecurringInvoice(recurring_invoice)">
                      <fa-icon
                        matTooltipClass="tooltip-space"
                        matTooltip="{{ 'edit' | translate }}"
                        class="text-success"
                        [icon]="['fas', 'pencil']">
                      </fa-icon>
                    </a>
                    <ng-container *fcHasPermission="'recurring_invoice:delete'; else disabledDeleteButton">
                      <a *ngIf="recurring_invoice.id"
                        class="pl-1 pr-1 pb-2 pt-2 cursor-pointer"
                        (click)="deleteRecord(recurring_invoice, siteIndex)">
                        <fa-icon
                          matTooltipClass="tooltip-space"
                          matTooltip="{{ 'delete' | translate }}"
                          class="text-warning"
                          [icon]="['fas', 'trash-alt']">
                        </fa-icon>
                      </a>
                    </ng-container>
                    <a *ngIf="recurring_invoice.id"
                      href="/#/recurring_invoices/{{ recurring_invoice.id }}"
                      class="pl-1 pr-1 pb-2 pt-2"
                      target="_blank">
                      <fa-icon
                        matTooltipClass="tooltip-space"
                        matTooltip="{{ 'view' | translate }}"
                        class="text-primary"
                        [icon]="['fas', 'eye']">
                      </fa-icon>
                    </a>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </table>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </ng-container>
  </ng-container>
</ng-template>

<ng-template #noRecordFound>
  <div *ngIf="!isForm" class="col-12 text-center no-record-found pt-2">
    {{ 'no_record_found' | translate }}
  </div>
</ng-template>

<ng-template #loading>
  <div class="col-12 text-center">
    <fa-icon [icon]="['fas','spinner']" [spin]="true" aria-hidden="true"></fa-icon>
  </div>
</ng-template>